'use strict';

/**
 * All JS for the Search actions server side
 *
 * @type {{agenda: waApp.controllers.Search.agenda, jobs: waApp.controllers.Search.obss, curriculaVitae: waApp.controllers.Search.curriculaVitae, profiles: waApp.controllers.Search.profiles, manufacturers: waApp.controllers.Search.manufacturers, projects: waApp.controllers.Search.projects, dailyNews: waApp.controllers.Search.dailyNews}}
 */
waApp.controllers.Search = {
	agenda: function () {
		waDateRangePicker.dateRangeFilter();

		$('#country-id').select2();
		$('#state-id').select2();
		$('#category-id').select2();
		let submitSearchForm = function () {
			document.getElementById('filter-form').submit();
		};

		$('#category-id').on('change', function (event) {
			event.preventDefault();
			submitSearchForm();
		});

		$('#country-id').on('change', function (event) {
			event.preventDefault();
			$('#state-id').val(null);
			submitSearchForm();
		});

		$('#state-id').on('change', function (event) {
			event.preventDefault();
			submitSearchForm();
		});

		$('#date-range-filter').on(
			'apply.daterangepicker',
			function (ev, picker) {
				$(this).val(
					picker.startDate.format('YYYY-MM-DD') +
					' - ' +
					picker.endDate.format('YYYY-MM-DD')
				);
				submitSearchForm();
			}
		);

		$('#date-range-filter').on(
			'cancel.daterangepicker',
			function (ev, picker) {
				$(this).val('');
				submitSearchForm();
			}
		);
	},
	jobs: function () {
		$('#country-id').select2();
		$('#state-id').select2();
		$('#category-id').select2();
		$('#job-type').select2();

		let stickyJobs = $('.ticker');
		if (stickyJobs.find('li').length > 3) {
			stickyJobs.easyTicker({
				interval: 3000,
				visible: 3,
			});
		}

		let submitSearchForm = function () {
			document.getElementById('filter-form').submit();
		};

		$('#country-id, #job-type, #category-id').on(
			'change',
			function (event) {
				event.preventDefault();
				submitSearchForm();
			}
		);
	},
	curriculaVitae: function () {
		$('#country-id').select2();
		$('#state-id').select2();
		$('#category-id').select2();
		$('#job-type').select2();

		let submitSearchForm = function () {
			document.getElementById('filter-form').submit();
		};

		$('#country-id').on('change', function (event) {
			$('#state-id').val('');
			event.preventDefault();
		});

		$('#country-id, #job-type, #category-id').on(
			'change',
			function (event) {
				event.preventDefault();
				submitSearchForm();
			}
		);
	},
	profiles: function () {
		$('#country-id').select2();
		$('#state-id').select2();
		$('#category-id').select2().maximizeSelect2Height();
		$('#company-size-id').select2();
		$('#founded').select2();

		$('#country-id').on('change', function (event) {
			$('#state-id').val('');
			event.preventDefault();
		});

		waUtils.noWrapArrowLink('.profile-panel h2');

		$('#specialization-id').select2();

		let grid = $('.grid-profiles').isotope({
			// options
			itemSelector: '.grid-item',
			transitionDuration: 0,
		});

		let elems = grid.isotope('getItemElements');

		setTimeout(function () {
			waAdSpace.calculateBannerCardHeight(elems, 400, 840, 420);
			grid.isotope('layout');
		}, 1002);

		document.addEventListener('DOMContentLoaded', function () {
			grid.isotope('layout');
		});
	},
	manufacturers: function () {
		$('#country-id').select2();
		$('#state-id').select2();

		$('#country-id').on('change', function (event) {
			$('#state-id').val('');
			event.preventDefault();
		});
	},
	projects: function () {
		console.log('got called');
		$('#country-id').select2();
		$('#state-id').select2();
		$('#cost').select2();
		$('#size').select2();
		$('#stories').select2();
		$('#status').select2();

		$('#country-id').on('change', function (event) {
			$('#state-id').val('');
			event.preventDefault();
		});

		// waUtils.noWrapArrowLink(".project-panel h2");

		let grid = $('.grid-projects').isotope({
			// options
			itemSelector: '.grid-item',
			transitionDuration: 0,
		});

		let elems = grid.isotope('getItemElements');

		setTimeout(function () {
			waAdSpace.calculateBannerCardHeight(elems, 400, 800, 400);
			grid.isotope('layout');
		}, 1002);

		document.addEventListener('DOMContentLoaded', function () {
			grid.isotope('layout');
		});
	},
	news: function () {
		let grid = $('.grid-news').isotope({
			// options
			itemSelector: '.grid-item',
			transitionDuration: 0,
		});

		let elems = grid.isotope('getItemElements');

		setTimeout(function () {
			waAdSpace.calculateBannerCardHeight(elems, 350, 700, 350);
			grid.isotope('layout');
		}, 1002);

		document.addEventListener('DOMContentLoaded', function () {
			grid.isotope('layout');
		});
	},
};
